export const certificationsData = [
  {
    id: 1,
    title: "Google AI Essentials",
    issuer: "Coursera",
    date: "2024",
    link: "https://coursera.org/verify/7UQMU4MAHGVH",
    skills: ["AI Fundamentals", "Machine Learning", "Ethical AI"],
    icon: "certificate"
  },
  {
    id: 2,
    title: "Data Analytics with Python",
    issuer: "NPTEL",
    date: "2024",
    link: "https://archive.nptel.ac.in/content/noc/NOC24/SEM1/Ecertificates/106/noc24-cs20/Course/NPTEL24CS20S105380434130354274.pdf",
    skills: ["Python", "Data Analytics", "Statistical Analysis"],
    icon: "chart-line"
  },
  {
    id: 3,
    title: "Introduction To Industry 4.0 And Industrial Internet Of Things",
    issuer: "NPTEL",
    date: "2024",
    link: "https://archive.nptel.ac.in/content/noc/NOC25/SEM1/Ecertificates/106/noc25-cs43/Course/NPTEL25CS43S24360392104329214.pdf",
    skills: ["Industrial IoT", "Industry 4.0", "Automation"],
    icon: "industry"
  },
  {
    id: 4,
    title: "Getting Started with Competitive Programming",
    issuer: "NPTEL",
    date: "2023",
    link: "https://archive.nptel.ac.in/content/noc/NOC24/SEM2/Ecertificates/106/noc24-cs103/Course/NPTEL24CS103S55240660403857068.pdf",
    skills: ["Algorithms", "Data Structures", "Problem Solving"],
    icon: "code"
  },
  {
    id: 5,
    title: "Python for Beginners",
    issuer: "Udemy",
    date: "2023",
    link: "https://www.udemy.com/certificate/UC-adadeb14-da11-410f-b510-811273a4d87e/",
    skills: ["Python Programming", "OOP", "Web Scraping"],
    icon: "python"
  },
  {
    id: 6,
    title: "GitHub Foundations",
    issuer: "GitHub",
    date: "2023",
    link: "https://www.credly.com/go/QeP2nJWo",
    skills: ["Version Control", "Git", "Collaboration"],
    icon: "github"
  },
  {
    id: 7,
    title: "Introduction to Large Language Models (LLMs)",
    issuer: "NPTEL",
    date: "2025",
    link: "https://archive.nptel.ac.in/content/noc/NOC25/SEM2/Ecertificates/106/noc25-cs161/Course/NPTEL25CS161S125430027010252209.pdf",
    skills: ["Python", "Data Analytics", "Statistical Analysis"],
    icon: "chart-line"
  }
];
